import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
    const location = useLocation().pathname;

    // Google business profile
    const handleOpenGoogleBusiness = () => {
        window.open("https://www.google.com/search?q=mv+nails+house&oq=mv+nails+house&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQIxgnMgYIAhBFGDsyDQgDEAAYhgMYgAQYigUyDQgEEAAYhgMYgAQYigUyBggFEEUYPTIGCAYQRRg9MgYIBxBFGD3SAQgyMTI3ajBqN6gCCLACAQ&sourceid=chrome&ie=UTF-8", "_blank");
    };

    // Instagram profile
    const handleOpenInstagram = () => {
        window.open("https://www.instagram.com/mv_nails_house/", "_blank"); // Replace with actual Instagram username
    };

    // Facebook profile
    const handleOpenFacebook = () => {
        window.open("https://www.facebook.com/profile.php?id=61572704594126", "_blank"); // Replace with actual Facebook username or page ID
    }; 

    return (
        <>
            <footer className="footer py-4" style={{ userSelect: "none" }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 text-lg-start">
                            {/* Copyright © Your Website 2023 */}
                        </div>
                        <div className="col-lg-4 my-3 my-lg-0">
                            <Link
                                className="btn btn-dark btn-social mx-2"
                                to={location}
                                aria-label="Instagram"
                                onClick={handleOpenInstagram}
                            >
                                <i className="fab fa-instagram" />
                            </Link>
                            <Link
                                className="btn btn-dark btn-social mx-2"
                                to={location}
                                aria-label="Facebook"
                                onClick={handleOpenFacebook}
                            >
                                <i className="fab fa-facebook-f" />
                            </Link>
                            <Link
                                className="btn btn-dark btn-social mx-2"
                                to={location}
                                aria-label="Google"
                                onClick={handleOpenGoogleBusiness}
                            >
                                <i className="fab fa-google" />
                            </Link>
                        </div>
                        {/* <div className="col-lg-4 text-lg-end">
                            <a className="link-dark text-decoration-none me-3" href="#!">
                                Privacy Policy
                            </a>
                            <a className="link-dark text-decoration-none" href="#!">
                                Terms of Use
                            </a>
                        </div> */}
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;